import disable from '../../hdrm/injections/bindings/disable';
import templateConstants from '../../template/constants';

const {
  PAGE_FOOTER_CODE_ELEMENT_ID,
  PAGE_HEADER_CODE_ELEMENT_ID,
  SITE_HEADER_CODE_ELEMENT_ID,
  SITE_FOOTER_CODE_ELEMENT_ID,
} = templateConstants;

// This is temporary solution which should be removed once we will introduce hooks to inject as dependency

const disablePageSettingsHTMLCode = (dom) => {
  const elementsWithUserCode = dom.querySelectorAll(
    `#${PAGE_FOOTER_CODE_ELEMENT_ID}, #${PAGE_HEADER_CODE_ELEMENT_ID}, #${SITE_HEADER_CODE_ELEMENT_ID}, #${SITE_FOOTER_CODE_ELEMENT_ID}`
  );

  elementsWithUserCode.forEach((element) => {
    disable.add(element);
  });
};

export default disablePageSettingsHTMLCode;
